import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { lazyReadOcsSettings } from 'owa-ocs-service-gql';
import { updateShouldExpandAllItemPartsMutator } from '../mutators/updateShouldExpandAllItemParts';

export default async function initializeExpandItemPartsPreference(): Promise<void> {
    const expandAllItemPartsSetting = await lazyReadOcsSettings.importAndExecute(
        getGlobalSettingsAccountMailboxInfo(),
        'GLOBAL',
        ['mail_reading_pane_expand_itemparts']
    );
    if (expandAllItemPartsSetting?.[0]) {
        updateShouldExpandAllItemPartsMutator(
            JSON.parse(expandAllItemPartsSetting[0].value) ?? false
        );
    } else {
        // In case of any errors, default to false
        updateShouldExpandAllItemPartsMutator(false);
    }
}
